/* Visitor-language strings from layout/theme.liquid (window.PulseUI), decoded from Liquid's HTML escaping (2026-10-21). */
function pui(k) {
  var v = window.PulseUI && window.PulseUI[k];
  return typeof v === 'string' ? v.replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&') : '';
}
/* PDP SIZE SHEET -- a phone-only bottom sheet standing in for the native picker.
   Andre, 2026-09-05 00:20: "the pop-up that comes up, the font is quite large.
   Can we reduce the font by 20%?" iOS draws the native <select> picker itself and
   no CSS of ours reaches it, so the only way to control that type is to stop
   showing the native picker on phones. Verified before building: clicking the
   select adds nothing to the DOM (appearance:none, 21 options, no overlay before
   or after), i.e. the popup was entirely the OS.

   THE RULE THIS FILE MUST NOT BREAK, from snippets/pulse-size-picker.liquid:
   the control the customer sees IS `name="id"`, so the value posted to /cart/add
   cannot drift from the visible selection. So the <select> STAYS, keeps its name,
   and remains the only source of truth. This sheet is an input device for it: it
   writes select.value and dispatches `change`, and every existing listener
   (price, state, ship window, the cart-line property, Dawn's <product-form>)
   runs exactly as it did. Nothing here posts, validates or stores anything.

   PROGRESSIVE ENHANCEMENT, deliberately. The select is hidden by a class this
   script adds, never by CSS in the stylesheet. If the script fails to parse, is
   blocked, or throws, the native control is still on screen and fully usable --
   the page degrades to precisely today's behaviour rather than to no size picker.

   Phone only (max-width: 860px, the theme's breakpoint). Desktop keeps the native
   dropdown, which is small and familiar there and was not the complaint. */
(function () {
  'use strict';

  var MQ = '(max-width: 860px)';
  var sel, trigger, sheet, scrim, list, lastFocus, mq;

  function scale() {
    try {
      if (window.PulseSizeScale && window.PulseSizeScale.get) return window.PulseSizeScale.get();
    } catch (e) {}
    return document.documentElement.getAttribute('data-size-scale') === 'm' ? 'm' : 'w';
  }

  /* The option already carries both readings, so the sheet never re-derives a
     size string -- same source as the dropdown and the cart line. */
  function labelFor(opt) {
    return opt.getAttribute(scale() === 'm' ? 'data-text-m' : 'data-text-w') || opt.textContent.trim();
  }

  function selectedOpt() {
    return sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
  }

  function syncTrigger() {
    var o = selectedOpt();
    var chosen = o && o.value;
    trigger.textContent = chosen ? labelFor(o) : (sel.options[0] ? sel.options[0].textContent.trim() : (pui('select_size') || 'Select a size'));
    trigger.setAttribute('data-chosen', chosen ? 'true' : 'false');
  }

  function buildList() {
    list.textContent = '';
    var i, opt, row;
    for (i = 0; i < sel.options.length; i++) {
      opt = sel.options[i];
      if (!opt.value) continue;                    /* the "Select a size" placeholder */
      row = document.createElement('button');
      row.type = 'button';
      row.className = 'pss__row';
      row.setAttribute('role', 'option');
      row.value = opt.value;
      row.dataset.idx = String(i);
      if (opt.disabled) { row.disabled = true; row.setAttribute('aria-disabled', 'true'); }
      if (opt.selected) { row.setAttribute('aria-selected', 'true'); row.classList.add('is-on'); }
      row.textContent = labelFor(opt);
      list.appendChild(row);
    }
  }

  function open() {
    if (!sheet.hidden) return;
    lastFocus = document.activeElement;
    buildList();
    sheet.hidden = false;
    scrim.hidden = false;
    document.body.classList.add('overflow-hidden');   /* the ONE existing open-overlay signal */
    /* A synchronous reflow, not rAF: a double rAF does not reliably fire inside
       the width harness and leaves the sheet parked off screen. */
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
    scrim.classList.add('is-open');
    var on = list.querySelector('.is-on') || list.querySelector('.pss__row:not([disabled])');
    /* Focus a beat later: the panel transitions visibility, and a synchronous
       focus() on an element still computing `hidden` does nothing. */
    setTimeout(function () { if (on) on.focus(); }, 60);
    if (window.trapFocus) { try { window.trapFocus(sheet, on || sheet); } catch (e) {} }
  }

  function close() {
    if (sheet.hidden) return;
    /* Blur first so a dismissal never shares a frame with a viewport change. */
    if (sheet.contains(document.activeElement)) { try { document.activeElement.blur(); } catch (e) {} }
    sheet.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    if (window.removeTrapFocus) { try { window.removeTrapFocus(); } catch (e) {} }
    /* [hidden] -> display:none at the END of the fade, never `visibility`. A
       fixed overlay hidden by visibility stays in the paint tree, which is how
       the size drawer once left its scrim painted over an unclickable page after
       an iOS keyboard dismissal. display:none leaves nothing to paint or tap. */
    var done = function () { sheet.hidden = true; scrim.hidden = true; };
    var t = setTimeout(done, 320);
    sheet.addEventListener('transitionend', function h(e) {
      if (e.target !== sheet) return;
      sheet.removeEventListener('transitionend', h); clearTimeout(t); done();
    });
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function choose(row) {
    if (!row || row.disabled) return;
    sel.selectedIndex = parseInt(row.dataset.idx, 10);
    /* `change` is what every existing listener is bound to; `input` too, for
       anything watching the newer event. The select's value is the only state. */
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    syncTrigger();
    close();
  }

  function enable(on) {
    if (!sel) return;
    sel.classList.toggle('pss-native-off', on);
    trigger.hidden = !on;
    if (!on && !sheet.hidden) close();
  }

  function init() {
    sel = document.querySelector('select[data-pulse-sizeselect]');
    if (!sel || !sel.form) return;

    trigger = document.createElement('button');
    trigger.type = 'button';                    /* never submit the product form */
    trigger.className = 'pss__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    sel.parentNode.insertBefore(trigger, sel.nextSibling);

    scrim = document.createElement('div');
    scrim.className = 'pss__scrim';
    scrim.hidden = true;

    sheet = document.createElement('div');
    sheet.className = 'pss';
    sheet.hidden = true;
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', sel.getAttribute('aria-label') || pui('choose_size') || 'Choose a size');
    /* Built with DOM methods rather than innerHTML. The string would have been a
       hardcoded literal, but a later edit interpolating a variant label or an
       aria-label into it would silently become an injection point. */
    var head = document.createElement('div');
    head.className = 'pss__head';
    var title = document.createElement('span');
    title.className = 'pss__title';
    title.textContent = sel.getAttribute('aria-label') || pui('size') || 'Size';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'pss__x';
    x.setAttribute('aria-label', pui('close') || 'Close');
    x.textContent = '×';
    head.appendChild(title);
    head.appendChild(x);
    list = document.createElement('div');
    list.className = 'pss__list';
    list.setAttribute('role', 'listbox');
    sheet.appendChild(head);
    sheet.appendChild(list);

    /* PORTAL TO <body>. main.content-for-layout carries z-index:1 and opens a
       stacking context, so a sheet left inside the section cannot rise above the
       fixed announcement bar and nav however high its own z-index. The size
       drawer and the quick-add sheet are both portalled for this reason. */
    document.body.appendChild(scrim);
    document.body.appendChild(sheet);

    trigger.addEventListener('click', open);
    scrim.addEventListener('click', close);
    sheet.querySelector('.pss__x').addEventListener('click', close);
    list.addEventListener('click', function (e) {
      var row = e.target.closest ? e.target.closest('.pss__row') : null;
      if (row) choose(row);
    });
    /* Escape on the document, not the element: bound to the sheet it dies the
       moment focus leaves it. */
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
    /* The select can also be changed by anything else (a size-chart Select
       button, a ?variant= deep link), so the trigger follows it rather than
       assuming it is the only writer. */
    sel.addEventListener('change', syncTrigger);

    try {
      if (window.PulseSizeScale && window.PulseSizeScale.onChange) {
        window.PulseSizeScale.onChange(function () {
          syncTrigger();
          if (!sheet.hidden) buildList();
        });
      }
    } catch (e) {}

    mq = window.matchMedia ? window.matchMedia(MQ) : null;
    if (!mq) return;
    var apply = function () { enable(mq.matches); };
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    syncTrigger();
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
